import _classCallCheck from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import Protocol from './protocol';
import Bridge from './lib/TVAJSBridge';
import { AtomError } from './lib/error';
import { getPayVip as _getPayVip } from './lib/service';
import env from '@tencent/vft-common/env';
var SUPPORTED_API = {
  getAppInfo: 1,
  getDeviceInfo: 1,
  getMainUserInfo: 1,
  getMainCookie: 1,
  getVideoInfo: 1,
  replayVideo: 1,
  actionLogin: 1,
  openUrl: 1,
  openWebview: 1,
  hideBackButton: 1,
  close: 1,
  closeH5: 1,
  refreshWKcookie: 1,
  publishMsgToAllWebView: 1,
  onPayFinish: 1,
  onH5LoadFinish: 1,
  setH5LayoutParams: 1,
  writeLog: 1,
  startPreview: 1,
  unlockVideo: 1,
  // 调用native上报接口，用于透传h5上报数据给终端实现上报逻辑
  doH5Report: 1
};
/**
 * TVAJSBridge
 * 内容分发场景，集成付费SDK，即可使用该JSBridge
 * @class TVAJSBridge
 * @extends {Protocol}
 */

var TVAJSBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(TVAJSBridge, _Protocol);

  var _super = _createSuper(TVAJSBridge);

  function TVAJSBridge() {
    var _this;

    _classCallCheck(this, TVAJSBridge);

    _this = _super.call(this);
    _this.name = 'TVAJSBridge';
    return _this;
  }
  /**
   * invoke
   * 调用内部定义方法或调用JSAPI
   * @param {String} api 接口名
   * @param {Object} params 参数
   * @param {Object} options 可选参数
   * @param {Number} options.timeout 超时时间，默认300ms，涉及用户交互的接口需要调用方加大超时时间
   * @returns
   */


  _createClass(TVAJSBridge, [{
    key: "invoke",
    value: function invoke() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 500
      };

      // 兼容直接invoke的场景，可直接调用内部抹平方法
      if (typeof this[api] === 'function') {
        return this[api](params, options);
      }

      if (!SUPPORTED_API[api]) {
        throw new AtomError("api \"".concat(api, "\" is not implemented"), AtomError.API_NOT_IMPLEMENTED);
      }

      return this.call(api, params, options);
    }
    /**
     * 真正调用Bridge
     * @param {String} api 接口名
     * @param {Object} params 参数
     * @param {Object} options 可选参数
     * @param {Number} options.timeout 超时时间，默认500ms，涉及用户交互的接口需要调用方加大超时时间
     * @returns
     */

  }, {
    key: "call",
    value: function call() {
      var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        timeout: 500
      };
      return new Promise(function (resolve, reject) {
        console.log("[TVAJSBridge] invoke ".concat(api, " params="), params);
        var timer;

        if (options.timeout > 0) {
          timer = setTimeout(function () {
            reject(new AtomError("[TVAJSBridge] invoke '".concat(api, "' timeout ").concat(options.timeout, "ms"), AtomError.BRIDGE_INVOKE_TIMEOUT));
          }, options.timeout);
        }

        Bridge.invoke(api, params || {}, function (res) {
          console.log("[TVAJSBridge] ".concat(api, " callback="), res);
          timer && clearTimeout(timer);

          if (res && res.errCode === 0) {
            resolve(res.result, res);
          } else {
            reject(new AtomError("[TVAJSBridge] inovke ".concat(api, " caught error \"").concat(res.errMsg, "(").concat(res.errCode, ")\""), res.errCode));
          }
        });
      });
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      Bridge.on(event, callback);
    }
    /**
     * 判断当前客户端版本是否支持指定 JS 接口
     * @param {Array} apiList - 接口列表
     * @returns {Promise}
     * @example <caption>Check availability of api `actionLogin` in iPad.</caption>
     * atom.checkApi(['actionLogin']).then(function(res) {
     *     console.log(JSON.stringify(res))
     * })
     */

  }, {
    key: "checkApi",
    value: function checkApi() {
      var apiList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var res = {};

      for (var i = 0; i < apiList.length; i++) {
        res[apiList[i]] = !!SUPPORTED_API[apiList[i]];
      }

      return Promise.resolve(res);
    }
    /**
     * 关闭webview
     */

  }, {
    key: "close",
    value: function close() {
      return this.call('close');
    }
  }, {
    key: "closeH5",
    value: function closeH5() {
      return this.call('closeH5');
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      Bridge.dispatchEvent(event);
    }
    /**
     * 拉起终端登录组件
     * 目前QQ浏览器复用该接口，支持拉起登录和切换账号面板
     * @param {String} type 账号类型，目前终端不支持指定账号类型登录
     * @returns
     */

  }, {
    key: "openLogin",
    value: function openLogin() {
      var _this2 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.call('actionLogin', {
        type: type
      }, {
        timeout: 300000
      }).then(function (res) {
        if (env.isQQSports && env.isIos) {
          // 临时处理,体育侧切换登录后cookie不更新问题,待终端修复版本
          location.reload();
        } // 登录成功事件推送


        _this2.postMessage('onActionLoginFinish', {
          errCode: 0,
          errMsg: ''
        });

        return res;
      });
    }
    /**
     * 切换账号
     * 当前仅QQ浏览器和动漫支持切换账号
     * @returns
     */

  }, {
    key: "switchLogin",
    value: function switchLogin() {
      if (!env.isMqb && !env.isAccomic && !env.isQQSports) {
        return this.toast('当前环境暂不支持切换账号，您可前往“我的 - 设置”切换账号');
      }

      return this.openLogin();
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      return this.call('getAppInfo');
    }
  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      return this.call('getDeviceInfo');
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      return this.call('getMainUserInfo').then(function (res) {
        if (!res || ['qq', 'wx'].indexOf(res.type) < 0 || !res.userInfo) {
          return null;
        }

        return {
          headurl: res.userInfo.headImgUrl,
          nick: res.userInfo.nickname,
          type: res.type
        };
      });
    }
  }, {
    key: "openUrl",
    value: function openUrl(url) {
      if (!url.match(/^https?:\/\//)) {
        // 非 http 协议，走openView拉起
        return this.openView(url);
      }

      if (navigator.userAgent.match(/TenvideoUnion\/v1\.0\.4/)) {
        // 修复1.0.4版本，调用openUrl失败问题
        location.href = url;
        return Promise.resolve();
      }

      return this.call('openUrl', {
        url: url
      });
    }
  }, {
    key: "openView",
    value: function openView(url) {
      if (env.isMqb && env.isIos) {
        // QQ浏览器iOS只能通过 sdk 内置 openUrl 方法拉起
        return this.call('openUrl', {
          url: url
        });
      }

      location.href = url;
      return Promise.resolve();
    }
  }, {
    key: "getPayVip",
    value: function getPayVip() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _getPayVip(param)["catch"](function (e) {
        console.error(e);
        return null;
      });
    }
  }, {
    key: "refreshVipInfo",
    value: function refreshVipInfo() {
      return this.call('refreshVipInfo');
    }
    /**
     * 全局推消息
     * 二次封装，抹平接口调用
     * @param {String} event - 事件名
     * @param {Object} params - 消息数据
     */

  }, {
    key: "postMessage",
    value: function postMessage() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.publishMsgToAllWebView({
        messageName: event,
        messageParams: params
      });
    }
    /**
     * 全局推消息
     * @param {Object} params - 消息数据
     * @param {String} params.messageName - 事件名
     * @param {Object} params.messageParams - 事件参数
     */

  }, {
    key: "publishMsgToAllWebView",
    value: function publishMsgToAllWebView() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.call('publishMsgToAllWebView', params);
    }
  }]);

  return TVAJSBridge;
}(Protocol);

export default new TVAJSBridge();